import React, { Component } from "react";
import Geocode from "react-geocode";
import { withTranslation } from "react-i18next";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import ReactSelect from "react-select";
import { Image } from "react-bootstrap";
import Button from "../../../../components/UI/Button/Button";
import ButtonAddon from "../../../../components/UI/ButtonAddon/ButtonAddon";
import Checkbox from "../../../../components/UI/Checkbox/Checkbox";
import Input from "../../../../components/UI/Input/Input";
import { logFirebaseEvent } from "../../../../shared/utility";
import * as findProviderActions from "../../../../store/actions/";
import classes from "./FindProviderSearch.module.css";
import infoIcon from "../../../../assets/images/info-icon.svg";
import dynamicMessages from "../../../../dynamicMessages";
import Modal from "../../../../components/UI/Modal/Modal";
import LoginAlert from "../../../../components/UI/Alerts/LoginAlert/LoginAlert";
import differenceBy from "lodash/differenceBy";
import filter from "lodash/filter";

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
interface IStateFromProps {
  providerType: { name: string; id: string }[];
  providerSpeciality: { name: string; id: string }[];
  error: string;
  params: {
    distance: number;
    longitude: string;
    latitude: string;
    postalCode: string;
    providerName: string;
    providerType: string;
    specialty: string;
    contractedStatus: string;
    scoreHigherThan: number;
    scoreLowerThan: number;
    isContracted: boolean;
    isFavorite: boolean;
    gender: string;
    fetchCurrentLocation: boolean;
    location: string;
    limit: string;
    currentAttempt: number;
    extendedDistance: number;
    isMore: boolean;
  };
  contracts: {
    name: string;
    value: string;
    isSelected: boolean;
  }[];
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  t: any;
  contractStatus:string;
  onContractStatusChanged:(contractStatus:string)=>void;
}
interface IDispatchFromProps {
  onFetchProviderType: () => void;
  onFetchProviderSpeciality: (providerTypeId: number) => void;
  onFetchProviders: (searchParams: {}) => void;
  onAddSearchParam: (
    name: string,
    value: string | number | boolean | null
  ) => void;
  onResetSearchParam: () => void;
  onFetchGroupSpecificContracts: () => void;
}
type Props = IStateFromProps & IDispatchFromProps;

class FindProviderSearch extends Component<Props> {
  state = {
    providerName: this.props.params.providerName,
    providerType: this.props.params.providerType,
    specialty: this.props.params.specialty,
    contractedStatus: [] as {
      label: string;
      value: string;
      isSelected: boolean;
    }[],
    distance: this.props.params.distance,
    changeMilesBy: 5,
    latitude: this.props.params.latitude,
    longitude: this.props.params.longitude,
    fetchCurrentLocation: this.props.params.fetchCurrentLocation,
    postalCode: this.props.params.postalCode,
    location: this.props.params.location,
    errorPostalCode: "",
    formValid: false,
    checkDisabled: false,
    notifyLocationMsg:
      "Allow location from browser settings to use current location",
    isMore: this.props.params.isMore,
    errorContracted: false,
    errorContractedPopup: false,
    contractSelection:''
  };
  componentDidMount() {
    this.props.onFetchProviderType();
    this.props.onFetchProviderSpeciality(0);
    if (this.props.params.fetchCurrentLocation) {
      this.getCurrentLocation();
    }
    this.props.onFetchGroupSpecificContracts();
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("this.state.contractedStatus", this.state.contractedStatus);
    // console.log("prevState.contractedStatus", prevState.contractedStatus);
    if (
      JSON.stringify(prevProps.contracts) !==
        JSON.stringify(this.props.contracts) &&
      this.props.contracts
    ) {
      let selectedContracts = this.props.contracts
        .filter((contract) => contract.isSelected)
        .map((contract) => ({
          value: contract.value,
          label: contract.name,
          isSelected: contract.isSelected,
        }));

      this.setState({ contractedStatus: selectedContracts });
      let selectedContracted: any;
      selectedContracted =
        selectedContracts &&
        selectedContracts.map((res) => encodeURIComponent(res.value));
      if (selectedContracts) {
        this.props.onAddSearchParam(
          "contractStatus",
          selectedContracted.join(",")
        );
        this.props.onContractStatusChanged(selectedContracted)
      } else {
        this.props.onAddSearchParam("contractStatus", "");
        this.props.onContractStatusChanged('')
      }
    }
  }

  getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.showPosition,
        this.showError
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };
  showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        this.setState({
          fetchCurrentLocation: false,
          checkDisabled: true,
        });
        this.props.onAddSearchParam(
          "fetchCurrentLocation",
          this.state.fetchCurrentLocation
        );
        break;
    }
  };
  showPosition = (position) => {
    this.setState({ latitude: position.coords.latitude });
    this.setState({ longitude: position.coords.longitude });
    // this.setState({ postalCode: "" });
    this.props.onAddSearchParam("latitude", this.state.latitude);
    this.props.onAddSearchParam("longitude", this.state.longitude);
    // this.props.onAddSearchParam("postalCode", "");
    Geocode.fromLatLng(
      position.coords.latitude,
      position.coords.longitude
    ).then(
      (response) => {
        this.setState({ location: response.results[0].formatted_address });
      },
      (error) => {
        console.error(error);
      }
    );
  };
  handleMinusDistance = () => {
    const { distance, changeMilesBy } = this.state;
    this.setState({
      distance: distance - changeMilesBy,
    });
    this.props.onAddSearchParam("distance", distance - changeMilesBy);
  };
  handlePlusDistance = () => {
    const { distance, changeMilesBy } = this.state;
    this.setState({
      distance: distance + changeMilesBy,
    });
    this.props.onAddSearchParam("distance", distance + changeMilesBy);
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    this.props.onAddSearchParam(e.target.name, e.target.value);
    // if (e.target.name === "providerType") {
    //   this.props.onFetchProviderSpeciality(e.target.value);
    //   this.props.onAddSearchParam("specialty", "");
    //   this.setState({
    //     specialty: "",
    //   });
    // }
    this.setState({
      errorPostalCode: "",
    });
  };

  handleChangeSelect = (selectedItems) => {
    logFirebaseEvent("Speciality");
    this.setState({
      specialty: selectedItems,
    });
    console.log("selectedItems", selectedItems);
    let selectedSpecialty: any;
    selectedSpecialty =
      selectedItems &&
      selectedItems.map((res) => encodeURIComponent(res.value));
    if (selectedItems) {
      this.props.onAddSearchParam("specialty", selectedSpecialty.join(","));
    } else {
      this.props.onAddSearchParam("specialty", "");
    }
    console.log("value of handle change select", selectedItems);
  };

  handleChangeContracted = (selectedItems) => {
    logFirebaseEvent("Contracted");
    console.log("this.state.contractedStatus", this.state.contractedStatus);
    console.log("selectedItems.contractedStatus", selectedItems);

    let filtered1 = differenceBy(
      this.state.contractedStatus,
      selectedItems,
      "label"
    );
    console.log("filtered contracted", filtered1);
    if (
      filter(
        filtered1,
        (f) => f.isSelected && f.label.toLowerCase() !== "contracted"
      ).length > 0
    ) {
      this.setState({ errorContracted: true });
    }
    this.setState({
      contractedStatus: selectedItems,
    });
    let selectedContracted: any;
    selectedContracted =
      selectedItems &&
      selectedItems.map((res) => encodeURIComponent(res.value));
    if (selectedItems) {
      this.props.onAddSearchParam(
        "contractStatus",
        selectedContracted.join(",")
      );
      this.props.onContractStatusChanged(selectedContracted)
    } else {
      this.props.onAddSearchParam("contractStatus", "");
      this.props.onContractStatusChanged('')
    }
    console.log("value of handle change select", selectedItems);
  };

  handleChangeProviderType = (selectedItems) => {
    logFirebaseEvent("ProviderType");
    this.setState({
      providerType: selectedItems,
    });
    if (selectedItems) {
      this.props.onAddSearchParam("providerType", selectedItems.value);
      this.props.onFetchProviderSpeciality(selectedItems.value);
    } else {
      this.props.onAddSearchParam("providerType", "");
      this.props.onFetchProviderSpeciality(0);
    }
    this.setState({
      specialty: "",
    });

    this.props.onAddSearchParam("specialty", "");
    // this.setState({
    //   specialty: "",
    // });
    this.setState({
      errorPostalCode: "",
    });
  };

  handleCheckboxSelection = () => {
    const getLocation = !this.state.fetchCurrentLocation;
    this.setState({ fetchCurrentLocation: getLocation });
    this.props.onAddSearchParam("fetchCurrentLocation", getLocation);
    if (getLocation) {
      this.getCurrentLocation();
    } else {
      this.setState({
        postalCode: "",
        latitude: null,
        longitude: null,
      });
      this.props.onAddSearchParam("postalCode", "");
      this.props.onAddSearchParam("latitude", null);
      this.props.onAddSearchParam("longitude", null);
    }
    this.setState({ errorPostalCode: "" });
  };
  isValidPostalCode = () => {
    let isValid = true;
    const { t } = this.props;
    if (!this.state.fetchCurrentLocation) {
      let regex = /^[0-9]{5}$/;
      if (!regex.test(this.state.postalCode)) {
        this.setState({
          errorPostalCode: t("findProviderPage.errorPostalCode"),
        });
        isValid = false;
      }
    }
    return isValid;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.isValidPostalCode()) {
      logFirebaseEvent("SearchButtonPressed");
      this.props.onAddSearchParam("currentAttempt", 0);
      // this.props.onFetchProviders(this.props.params);
      if (
        this.props.params.isContracted ||
        this.props.params.scoreLowerThan < 10 ||
        this.props.params.scoreHigherThan > 0 ||
        this.props.params.gender !== "Gender"
      ) {
        this.props.onAddSearchParam("isMore", true);
      } else {
        this.props.onAddSearchParam("isMore", false);
      }
    }
  };
  verifyState = () => {
    return (this.props.params.postalCode === null ||
      this.props.params.postalCode === "") &&
      (this.props.params.latitude === null ||
        this.props.params.latitude === "" ||
        this.props.params.longitude === null ||
        this.props.params.longitude === "")
      ? true
      : false;
  };
  errorAlertHandler = () => {
    this.setState({ errorContracted: false });
  };
  render() {
    const { t } = this.props;
    console.log(this.props.params);
    const elementLabelStyle = {
      fontSize: "13px",
      fontWeight: "600",
      color: "#117093",
      marginBottom: "3px",
    };
    const nextBtnStyle = {
      width: "100%",
      marginTop: "5px",
    };
    const elementInputStyle = {};
    const required = (
      <span style={{ color: "red" }}> {t("findProviderPage.required")}</span>
    );

    // let providerTypes = [this.state.providerType];
    // if (this.props.providerType) {
    //   providerTypes = providerTypes.concat(
    //     this.props.providerType
    //       .map((res) => res)
    //       .filter((value) => !providerTypes.includes(value))
    //   );
    // }
    let providerTypes: { value: string; label: string }[] = [];

    if (this.props.providerType) {
      providerTypes = this.props.providerType.map((res) => ({
        value: res.id,
        label: res.name,
      }));
    }
    let specialityTypes: { value: string; label: string }[] = [];

    if (this.props.providerSpeciality) {
      specialityTypes = this.props.providerSpeciality.map((res) => ({
        value: res.id,
        label: res.name,
      }));
    }

    let contracts: { value: string; label: string; isSelected: boolean }[] = [];
    if (this.props.contracts) {
      contracts = this.props.contracts.map((contract) => ({
        value: contract.value,
        label: contract.name,
        isSelected: contract.isSelected,
      }));
    }

    //  let specialityTypes;

    //     if (
    //       this.props.providerSpeciality &&
    //       this.props.providerSpeciality["result"]
    //     ) {
    //       specialityTypes =
    //         this.props.providerSpeciality &&
    //         this.props.providerSpeciality["result"] &&
    //         this.props.providerSpeciality["result"].map((res) => res);
    //     }
    let location;
    if (this.state.fetchCurrentLocation) {
      location = (
        <Input
          label={t("findProviderPage.location")}
          mandatoryLabel={required}
          supportLabel=""
          placeholder={t("placeHolder.address")}
          elementLabelStyle={elementLabelStyle}
          elementInputStyle={elementInputStyle}
          name="location"
          errorText={this.state.errorPostalCode}
          value={this.state.location}
          readOnly={this.state.fetchCurrentLocation}
        />
      );
    }
    let postalCode;
    if (!this.state.fetchCurrentLocation) {
      postalCode = (
        <div className="form-group">
          {/* {t('findProviderPage.location')} */}
          <label className="form-label">
            {t("findProviderPage.location")}{" "}
            <span className={classes.mandatoryLabel}>
              {" "}
              {t("findProviderPage.required")}
            </span>
          </label>
          <NumberFormat
            format="#####"
            placeholder={t("placeHolder.zipCode")}
            name="postalCode"
            value={this.state.postalCode}
            className="form-control"
            onChange={(e) => this.handleChange(e)}
          />
          <span className={classes.errorMsg}>{this.state.errorPostalCode}</span>
        </div>
      );
    }

    const modalChildStyle = {};
    /*error message display*/
    let errorMessagePopup: any;
    if (
      this.props.contracts.some(
        (contract) =>
          contract.isSelected &&
          contract.name.toLowerCase() !== "contracted" &&
          !this.state.contractedStatus
      ) ||
      this.props.contracts.some(
        (contract) =>
          contract.isSelected &&
          contract.name.toLowerCase() !== "contracted" &&
          !this.state.contractedStatus.some(
            (contracted) =>
              contracted.label.toLowerCase() !== "contracted" &&
              contract.name === contracted.label
          )
      )
    ) {
      errorMessagePopup = (
        <Modal
          show={this.state.errorContracted}
          childComp={
            <LoginAlert
              modalClosed={this.errorAlertHandler}
              infoText={
                this.props.config_values &&
                this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Find Provider".toLowerCase() &&
                    ele.element.toLowerCase() ===
                      "Find Provider Contract Status".toLowerCase()
                )
                  ? this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Find Provider".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Find Provider Contract Status".toLowerCase()
                    )?.customValue
                    ? this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Find Provider".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Find Provider Contract Status".toLowerCase()
                        )
                        ?.customValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {dynamicMessages(item)
                                ? t(dynamicMessages(item))
                                : item}
                              <br />
                            </span>
                          );
                        })
                    : this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Find Provider".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Find Provider Contract Status".toLowerCase()
                        )
                        ?.defaultValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {dynamicMessages(item)
                                ? t(dynamicMessages(item))
                                : item}
                              <br />
                            </span>
                          );
                        })
                  : ``
              }
            />
          }
          style={modalChildStyle}
        />
      );
    }

    return (
      <div>
        {location}
        {postalCode}
        {errorMessagePopup}
        <Checkbox
          label={t("findProviderPage.userLocation")}
          //defaultChecked={this.state.fetchCurrentLocation}
          onChange={this.handleCheckboxSelection}
          id="location"
          checked={this.props.params.fetchCurrentLocation}
          disabled={this.state.checkDisabled}
        />
        {/* {this.state.checkDisabled ? 
          <p style={{color: "red", fontSize: "11px"}}>{this.state.notifyLocationMsg}</p>
          : null} */}
        <ButtonAddon
          label={t("findProviderPage.distance")}
          firstBtnLabel="-"
          secondBtnLabel="+"
          elementLabelStyle={elementLabelStyle}
          elementInputStyle={elementInputStyle}
          onClickPlus={this.handleMinusDistance}
          onClickMinus={this.handlePlusDistance}
          name="distance"
          errorText=""
          value={this.state.distance}
          onChange={(e) => this.handleChange(e)}
          readOnly
          subtext={" " + t("findProviderPage.Miles")}
          maxVal={100}
        />

        <Input
          label={t("findProviderPage.providerName")}
          supportLabel=""
          placeholder={t("findProviderPage.providerName")}
          elementLabelStyle={elementLabelStyle}
          elementInputStyle={elementInputStyle}
          name="providerName"
          errorText=""
          value={this.props.params.providerName}
          onChange={(e) => this.handleChange(e)}
        />
        {/* <Select
          label="Provider Type"
          supportLabel=""
          options={providerTypes}
          elementLabelStyle={elementLabelStyle}
          elementInputStyle={elementInputStyle}
          errorText=""
          value={this.state.providerType}
          onChange={(e) => this.handleChange(e)}
          name="providerType"
        /> */}
        <div className="form-group">
          <label className="form-label">
            {t("findProviderPage.providerType")}
          </label>
          <ReactSelect
            value={this.state.providerType}
            onChange={this.handleChangeProviderType}
            options={providerTypes}
            name={t("findProviderPage.providerType")}
            className="multiSelect"
            isClearable={true}
          />
        </div>
        {/* <Select
          label="Speciality"
          supportLabel=""
          options={specialityTypes}
          elementLabelStyle={elementLabelStyle}
          elementInputStyle={elementInputStyle}
          name="specialty"
          errorText=""
          value={this.state.specialty}
          onChange={(e) => this.handleChange(e)}
        /> */}
        <div className="form-group">
          <label className="form-label">
            {t("findProviderPage.speciality")}
          </label>

          <ReactSelect
            value={this.state.specialty}
            onChange={this.handleChangeSelect}
            options={specialityTypes}
            name="specialty"
            className="multiSelect"
            isMulti
          />
        </div>
        <div className="form-group">
          <label className="form-label">
            {t("findProviderPage.contractedStatus")}
          </label>
          {this.props.contracts.some(
            (contract) =>
              contract.isSelected &&
              contract.name.toLowerCase() !== "contracted" &&
              !this.state.contractedStatus
          ) ||
          this.props.contracts.some(
            (contract) =>
              contract.isSelected &&
              contract.name.toLowerCase() !== "contracted" &&
              !this.state.contractedStatus.some(
                (contracted) =>
                  contracted.label.toLowerCase() !== "contracted" &&
                  contract.name === contracted.label
              )
          ) ? (
            <div className="hover-popup float-right">
              <a role="button">
                <Image src={infoIcon} alt={infoIcon} />
              </a>
              <div className="info-popup">
                {/* {t("findProviderPage.contractGroupStatus")} */}

                {this.props.config_values &&
                this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Find Provider".toLowerCase() &&
                    ele.element.toLowerCase() ===
                      "Find Provider Contract Status".toLowerCase()
                )
                  ? this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Find Provider".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Find Provider Contract Status".toLowerCase()
                    )?.customValue
                    ? this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Find Provider".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Find Provider Contract Status".toLowerCase()
                        )
                        ?.customValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {dynamicMessages(item)
                                ? t(dynamicMessages(item))
                                : item}
                              <br />
                            </span>
                          );
                        })
                    : this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Find Provider".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Find Provider Contract Status".toLowerCase()
                        )
                        ?.defaultValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {dynamicMessages(item)
                                ? t(dynamicMessages(item))
                                : item}
                              <br />
                            </span>
                          );
                        })
                  : ``}
              </div>
            </div>
          ) : null}
          <div className="clear"></div>
          <ReactSelect
            value={this.state.contractedStatus}
            onChange={this.handleChangeContracted}
            options={contracts}
            name="ContractedStatus"
            className="multiSelect"
            defaultValue={this.state.contractedStatus}
            isMulti
          />
        </div>
        <Button
          label={t("findProviderPage.searchButton")}
          style={nextBtnStyle}
          clicked={this.handleSubmit}
          displayImg={false}
          image=""
          disabled={this.verifyState()}
        />
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  providerType: state.findProvider.providerType,
  providerSpeciality: state.findProvider.providerSpeciality,
  error: state.findProvider.error,
  params: state.searchURL.params,
  contracts: state.fetchGroupSpecificContracts.contracts,
  config_values: state.appConfig.config_values,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchProviderType: () => dispatch(findProviderActions.fetchProviderType()),
  onFetchProviderSpeciality: (providerTypeId: number) =>
    dispatch(findProviderActions.fetchProviderSpecialities(providerTypeId)),
  onFetchProviders: (searchParams) =>
    dispatch(findProviderActions.fetchProviders(searchParams)),
  onAddSearchParam: (param, value) =>
    dispatch(findProviderActions.constructSearchURL(param, value)),
  onResetSearchParam: () => dispatch(findProviderActions.resetSearchParam()),
  onFetchGroupSpecificContracts: () =>
    dispatch(findProviderActions.fetchGroupSpecificContracts()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FindProviderSearch));
